// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hS","loading":"hT","b":"hU","errorMsg":"hV","loadingMsg":"hW","successMsg":"hX","hideLoadingMsg":"hY","completed":"hZ","a":"h0","kidsGreen":"h1"};